export class ConfigColumnMap {
    sourceColumnName = '';
    targetColumnName = '';

    constructor(sourceColumn: string, targetColumn: string) {
        this.sourceColumnName = sourceColumn;
        this.targetColumnName = targetColumn;
    }
}
